import { useCallback, useRef } from "react";

import { useOpenModal } from "@/components/modal/utils/openModal";

const useChatWindow = (
  ladyId: number | undefined,
  setIsRoseSent?: (value: boolean) => void,

  isCamAvailable?: boolean | undefined,
) => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const { openModal: openLightModal, removeOne } = useOpenModal({
    disableScrollActions: true,
    onOkClick: () => handleClose(),
  });

  const handleClose = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    removeOne();
  }, [removeOne]);
  const openChatWindow = useCallback(
    (actionType: "liveChat" | "sendRose") => {
      const baseUrl = "/chat#!CHAT";
      let url = "";

      const openAlreadyOpenModal = (message: string) => {
        openLightModal("INFORMATION_MODAL", {
          message,
          statusReg: "success",
          buttonText: "Ok",
          onOkClick: handleClose,
        });

        timeoutRef.current = setTimeout(() => {
          removeOne();
          timeoutRef.current = null;
        }, 5000);
      };

      switch (actionType) {
        case "liveChat":
          url = isCamAvailable
            ? `${baseUrl};${ladyId};true;`
            : `${baseUrl};${ladyId};false;`;
          break;
        case "sendRose":
          url = `${baseUrl};${ladyId};false;Rose;`;
          setIsRoseSent && setIsRoseSent(true);
          break;
      }

      const w = 1180;
      const h = 700;
      if (window.openedChatWindow && !window.openedChatWindow.closed) {
        openAlreadyOpenModal("Live Chat is already open in another window!");
        window.openedChatWindow.focus();
      }

      window.openedChatWindow = window.open(
        url,
        "gb_widget",
        `scrollbars=1,height=${Math.min(
          h,
          screen.availHeight,
        )},width=${Math.min(w, screen.availWidth)},left=${Math.max(
          0,
          (screen.availWidth - w) / 2,
        )},top=${Math.max(0, (screen.availHeight - h) / 2)}`,
      );
    },
    [
      openLightModal,
      handleClose,
      removeOne,
      isCamAvailable,
      ladyId,
      setIsRoseSent,
    ],
  );

  return openChatWindow;
};

export default useChatWindow;
